import React from "react";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import { useGlobalStore } from "@/store/hooks";
import WithPopoverTip, { getRealBuyerNickName } from "../WithPopoverTip";

interface XhsBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

function buildXhsChatUrl(customerId: string, sellerId: string) {
    return `eva:?type=createChat&customerId=${customerId}&sellerId=${sellerId}`;
}

const XhsBuyerUsername: React.FC<XhsBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    const globalStore = useGlobalStore();
    const sellerId = globalStore.shopMapping.get(order.shopId)?.sellerId;
    const buyerUsername = <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>;

    /** 旧非待发货订单数据小于10位 无法唤醒IM 三个月后可删除这个判断 */
    if (!order.buyerUsername || !sellerId || order.buyerUsername.length <= 10) {
        return buyerUsername;
    }

    return (
        <span>
            {buyerUsername}

            <a href={buildXhsChatUrl(order.buyerUsername, sellerId)} title="联系买家">
                <svg
                    data-v-4c8cf2bc=""
                    viewBox="0 0 24 24"
                    role="img"
                    style={{ fontSize: "12px", width: "16px", height: "16px", fill: "rgba(58,100,255)" }}
                >
                    <path
                        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3-13a3 3 0 11-6 0 3 3 0 016 0zm-8 7.333A3.333 3.333 0 0110.333 13h3.334A3.333 3.333 0 0117 16.333c0 .92-.746 1.667-1.667 1.667H8.667C7.747 18 7 17.254 7 16.333z"
                        clip-rule="evenodd"
                        fill-rule="evenodd"
                    ></path>
                </svg>
            </a>
        </span>
    );
});

export default XhsBuyerUsername;
